import React from "react";
import "./Banner.css";

const Banner = ({
  bgColor,
  title,
  subtitle,
  showActionButton = false,
  actionLabel = "Open",
  onAction,
  onClose,
}) => {
  return (
    <div className="banner-wrapper">
      <div className="banner-inner" style={{ background: bgColor }}>
        <div className="banner-text">
          {title != null && <div className="banner-title">{title}</div>}
          {subtitle != null && subtitle !== "" && (
            <div className="banner-subtitle">{subtitle}</div>
          )}
        </div>
        {showActionButton &&
          (typeof onAction === "function" || typeof onClose === "function") && (
          <div className="banner-actions">
            {typeof onAction === "function" && (
              <button
                type="button"
                className="banner-action-btn"
                onClick={onAction}
              >
                {actionLabel}
              </button>
            )}
            {typeof onClose === "function" && (
              <button
                type="button"
                className="banner-close-btn"
                onClick={onClose}
                aria-label="Close"
              >
                ✕
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Banner;
